// core
import { Component, OnInit, Input } from "@angular/core";

// models
import { VehicleCanbus, Canbus, Sensor } from '../../dataModels/sensors-tab-form';
import { Filtration, FilterSearchCriteria, Operator, FilterSortCriteria, SortDirection, FilterCriteria, RelationalLogicalOperator, LookUpTableName, LookUp } from "../../dataModels";

// services
import { LookupService } from '../../services/lookup.service';
import { SensorTabService } from '../../services/sensors-tab-form.service';
// import { Array } from "core-js";

@Component({
    moduleId: module.id,
    selector: 'canbus-tab-form',
    templateUrl: 'canbus-tab-form.component.html',
    styleUrls: ['./canbus-tab-form.component.scss'],
})

export class CanbusTabComponent implements OnInit {
    @Input("trackedObjectId") trackedObjectId: number;
    @Input("deviceConfigurationData") deviceConfigurationData: any = {};
    CanbusList: Sensor[] = [];
    CanbusListDefault: Canbus[] = [];
    CanbusListDefaultNoChange: Canbus[] = [];
    CanbusListPaging: Canbus[] = [];
    showList: boolean = false;
    Valid: boolean = true;
    public saveSucceedVicheleMessage: boolean = false;
    SensorTypeLookup: LookUp[] = [];
    public PageNumber: number = 1;
    public PageSize: number = 10;
    public CanbusListCount: number = 0;
    canbusFiltration: Filtration = new Filtration();

    constructor(private sensorService: SensorTabService, private lookupService: LookupService) {
    }

    ngOnInit(): void {
        this.lookupService.getCoreLookup(LookUpTableName.SensorType).then(res => this.SensorTypeLookup = res);
        //console.log("ngOnInit");
        
    }


    setCanbusData() {
//console.log("setCanbusData");
        
        if (this.deviceConfigurationData.AllowCanbus) {
            var filterCriteria: FilterCriteria = new FilterCriteria();
            filterCriteria.PageCriteria.PageNumber = -1;
            filterCriteria.SearchCriteria.push({ Operator: Operator.Equal, SearchKey: this.trackedObjectId.toString(), Field: "TrackedObjectId", RelationOperator: RelationalLogicalOperator.And });
            filterCriteria.SearchCriteria.push({ Operator: Operator.Equal, SearchKey: 0 + "", Field: "PortNumber", RelationOperator: RelationalLogicalOperator.And });
            this.sensorService.getSensorData(filterCriteria).subscribe(result => {
                if (result && !result.IsErrorState) {
                    this.CanbusList = result.Value.Collection;
                    if (this.CanbusList.length == 0) {
                        this.showList = false;
                        this.getCanbusDefaultData(this.deviceConfigurationData.DeviceModelId, this.trackedObjectId);
                    }
                    else {
                        this.CanbusListDefault = this.CanbusList.map(c => {
                            return {
                                SensorName: c.SensorName,
                                SensorTypeId: c.SensorTypeId,
                                SensorType: this.SensorTypeLookup.find(x => x.Id == c.SensorTypeId).DisplayName,
                                SensorId: c.Id,
                                PropertyId: this.SensorTypeLookup.find(x => x.Id == c.SensorTypeId).ExtraFields.PropertyId
                            }
                        })
                        this.showList = true;
                        this.CanbusListPaging = this.CanbusListDefault.slice((this.PageNumber - 1) * this.PageSize, (this.PageNumber - 1) * this.PageSize + this.PageSize);
                        this.CanbusListCount = this.CanbusListDefault.length;
                    }
                }
            }
            );
            
        }
    }

    getCanbusDefaultData(modelId: number,vehicleId:number) {
        //console.log("getCanbusDefaultData");
        //console.log("modelId", modelId);
        //console.log("vehicleId", vehicleId);
        
        var filtration = new Filtration();
        filtration.PageCriteria.PageNumber = -1;
        filtration.SearchCriteria.push(new FilterSearchCriteria("ModelId", Operator.Equal, modelId.toString(), RelationalLogicalOperator.And));
        filtration.SearchCriteria.push(new FilterSearchCriteria("TrackedObjectId", Operator.Equal, vehicleId.toString(), RelationalLogicalOperator.And));
        this.showList = true;
        this.sensorService.getCanbusDefaultData(filtration).subscribe(res => {
            if (res && !res.IsErrorState) {
                this.CanbusListDefault = res.Value.Collection.map(x => {
                    if (!x.SensorName) {
                        this.showList = false;
                        x.SensorName = x.SensorType;
                        x.SensorId = 0;
                    }
                    return x;
                });

   
   // const arrayUniqueByKey = Array.from(new Map(this.CanbusListDefault.map((item): [any, any] => [item.SensorTypeId, item])).values());
    const arrayUniqueByKey=[...new Map(this.CanbusListDefault.map((item): [any, any] => [item.SensorTypeId, item])).values()];
//console.log("arrayUniqueByKey", arrayUniqueByKey);


                this.CanbusListDefault = JSON.parse(JSON.stringify(arrayUniqueByKey));
                this.CanbusListDefaultNoChange = JSON.parse(JSON.stringify(arrayUniqueByKey));
              

                  this.CanbusListPaging = this.CanbusListDefault.slice((this.PageNumber - 1) * this.PageSize, (this.PageNumber - 1) * this.PageSize + this.PageSize);
                this.CanbusListCount = this.CanbusListDefault.length;
            }


        });
    }

    saveCanbusData() {
//console.log("saveCanbusData");
        
        if (!this.showList) {
            this.sensorService.deleteCanbusData(this.trackedObjectId).subscribe(res => {
                if (res && !res.IsErrorState) {
                    this.showSaveSuccessMessge();
                    this.CanbusList = [];
                    this.CanbusListPaging = [];
                    this.CanbusListDefault = JSON.parse(JSON.stringify(this.CanbusListDefaultNoChange));

                    this.CanbusListCount = this.CanbusListDefaultNoChange.length;
                    var p = {page:1}
                    this.pageChanged(p);
                }
            });
        }
        else if (this.validateAll() && this.showList) {
            var canbusdtos: Canbus[] = this.CanbusListDefault.map(c => {
                return {
                    PropertyId: c.PropertyId,
                    SensorId: c.SensorId?c.SensorId:0,
                    SensorName: c.SensorName,
                    SensorTypeId: c.SensorTypeId,
                    SensorType: c.SensorType
                }
            });
            var vehicleCanbus: VehicleCanbus = {
                TrackedObjectId : this.trackedObjectId,
                ModelId : this.deviceConfigurationData.DeviceModelId,
                SensorCanbusDTO: canbusdtos
            };
            this.sensorService.saveCanbusData(vehicleCanbus).subscribe(res => {
                if (res && !res.IsErrorState) {
                    this.setCanbusData();
                    this.showSaveSuccessMessge();
                    //console.log(res.Value)
                }
            })

        }
    }

    isDuplicate(data, index): boolean {
        //console.log("isDuplicate", "data", data);
        
        var duplicate = this.CanbusListDefault.filter((c, i) => c.SensorName == data.SensorName && c.SensorTypeId != data.SensorTypeId);
        if (duplicate.length > 0) {
            return true;
        }
         duplicate = this.deviceConfigurationData.sensorData.filter((c, i) => c.SensorName == data.SensorName);
        if (duplicate.length > 0) {
            return true;
        }
        return false;
    }

    isEmpty(data, index): boolean {
        //console.log("isEmpty", "data", data);
        
        if (data.SensorName == '') {
            return true;
        }
        else {
            return false;
        }
    }

    validateAll():boolean {
        //console.log("validateAll");
        //console.log("this.CanbusListDefault", this.CanbusListDefault);

     //  var unique = Array.from(new Set(this.CanbusListDefault.map(item => item.SensorName)));
        var unique = [...new Set(this.CanbusListDefault.map(item => item.SensorName))];

        var duplicate = this.deviceConfigurationData.sensorData.filter((c, i) => unique.includes(c.SensorName));
        
        if (unique.length != this.CanbusListDefault.length || this.CanbusListDefault.some(c => c.SensorName == '') || duplicate.length>0) {
            return false;
        }
       
        return true;
    }

    showSaveSuccessMessge() {
        //console.log("showSaveSuccessMessge");
        
        this.saveSucceedVicheleMessage = true;
        setTimeout(() => { this.saveSucceedVicheleMessage = false }, 5000);
    }

    pageChanged(event) {
        //console.log("pageChanged", "event", event);
        
        this.PageNumber = event.page;
        this.CanbusListPaging = this.CanbusListDefault.slice((this.PageNumber - 1) * this.PageSize, (this.PageNumber - 1) * this.PageSize + this.PageSize);
    }


    //enableCanbus(event) {
    //    //this.showList
    //    //this.canbusFiltration.PageCriteria = { PageNumber: -1, PageSize: this.PageSize };
    //    //this.canbusFiltration.SearchCriteria = [new FilterSearchCriteria("TrackedObjectId", Operator.Equal, this.trackedObjectId + "")];
    //    //this.canbusFiltration.SortCriteria = { Field: "SensorName", Direction: SortDirection.ASC }
    //    //this.sensorService.getCanbusDefaultData(this.canbusFiltration).subscribe(res => {
    //    //    //debugger;
    //    //    this.CanbusListDefault = res.Value.Collection;
    //    //    this.CanbusListPaging = this.CanbusListDefault.slice((this.PageNumber - 1) * this.PageSize, (this.PageNumber - 1) * this.PageSize + this.PageSize);
    //    //    this.CanbusListCount = this.CanbusListDefault.length;
    //    //})
    //}
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/canbusTabForm/canbus-tab-form.component.ts